import React from "react";
import Market from "../../component/market/index";

export function MarketComponent() {
  return (
   
      <Market />
    
  );
}
